import React from 'react';
import { Box, Center, Image, Button, Heading, Text } from '@chakra-ui/react';

import WithAnimation from '@/components/Common/WithAnimation';
import LazyImage from '@/components/Common/LazyImage';
import useLang from '@/hooks/useLang';

import { IG_FILTER_URL } from '@/constants';
import { BUTTON_PADDING_PROPS, BUTTON_PROPS } from '@/constants/colors';
import { ASSETS_FLOWER_2, BG_INSTAGRAM_FILTER } from '@/constants/assets';
import { TEXT_PROPS } from '@/constants/default-props';

import txt from './locales';

function InstagramFilter() {
  const lang = useLang();
  const isTemplateURL = location.pathname.includes('/template-');

  return (
    <Box marginTop="72px" mb="24px" pos="relative">
      {/* IMAGE CENTER */}
      <Box padding="24px" width="350px" mx="auto">
        <Center>
          <WithAnimation>
            <Heading {...TEXT_PROPS.heading} textTransform="none" px="8px">
              Wedding Filter
            </Heading>
          </WithAnimation>
        </Center>
        <WithAnimation>
          <Text {...TEXT_PROPS.body} align="center" padding="16px 12px">
            {txt.subTitle[lang]}
          </Text>
        </WithAnimation>
      </Box>
      <WithAnimation type="zoom">
        <Box pos="relative" width="300px" mx="auto">
          <LazyImage
            src={BG_INSTAGRAM_FILTER}
            width="100%"
            maxW="300px"
            height="auto"
            margin="0 auto"
            pos="relative"
          />
          {isTemplateURL && (
            <Text
              textAlign="center"
              fontStyle="italic"
              fontWeight="bold"
              color="mainColorText"
              fontFamily="body"
              mt="24px"
            >
              *) Filter Instagram tidak masuk dalam paket
            </Text>
          )}
          {/* ASSETS RIGHT */}
          <Box pos="absolute" top="-50px" right="-55px" transform="rotateY(180deg)">
            <WithAnimation>
              <Image src={ASSETS_FLOWER_2} width="110px" transform="rotate(36deg)" />
            </WithAnimation>
          </Box>
          {/* ASSETS LEFT */}
          <Box pos="absolute" bottom={isTemplateURL ? '20px' : '-30px'} left="-55px">
            <WithAnimation>
              <Image src={ASSETS_FLOWER_2} width="110px" transform="rotate(36deg)" />
            </WithAnimation>
          </Box>
        </Box>
      </WithAnimation>
      <Box padding="0 32px">
        {/* Button Section */}
        <WithAnimation>
          <Center>
            <a href={IG_FILTER_URL} target="_blank" rel="noreferrer">
              <Button size="sm" margin="16px 0 32px 0" {...BUTTON_PROPS} {...BUTTON_PADDING_PROPS}>
                {txt.textButton[lang]}
              </Button>
            </a>
          </Center>
        </WithAnimation>
      </Box>
    </Box>
  );
}

export default React.memo(InstagramFilter);
